import { Box } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import * as React from 'react';
import { RangeDatePicker } from 'ui-components';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooterDefault,
  ModalHeaderDefault,
} from 'ui-components/dist/Modal';
import { timeFrameToDays } from '~/components/ContentSearchPostedAtTimeframe/ContentSearchPostedAtTimeframe';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  postedAfter: string | null;
  postedBefore: string | null;
  onFilter: (postedAfter?: string | null, postedBefore?: string | null) => void;
}

interface FormValues {
  startDate?: string;
  endDate?: string;
}

export function PostedAtDateTimePickerModal({
  isOpen,
  onClose,
  postedAfter,
  postedBefore,
  onFilter,
}: Readonly<Props>) {
  const initialFormValues: FormValues = {};

  if (postedAfter && !(postedAfter in timeFrameToDays)) {
    initialFormValues.startDate = postedAfter.split('T')[0];
  }

  if (postedBefore) {
    initialFormValues.endDate = postedBefore.split('T')[0];
  }

  const handleSubmit = (values: FormValues) => {
    onFilter(values.startDate, values.endDate);
    onClose();
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      disableModalContent
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <Formik initialValues={initialFormValues} onSubmit={handleSubmit}>
        <ModalContent as={Form}>
          <ModalHeaderDefault title="Custom range" />
          <ModalBody>
            <Box paddingY={1}>
              <RangeDatePicker
                startDateLabel={'Start date'}
                endDateLabel={'End date'}
                minYear={2000}
                maxYear={new Date().getFullYear()}
              />
            </Box>
          </ModalBody>
          <ModalFooterDefault
            primary={{
              title: 'Select',
              type: 'submit',
            }}
            secondary={{
              onClick: onClose,
              title: 'Cancel',
            }}
          />
        </ModalContent>
      </Formik>
    </Modal>
  );
}
